module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.403add9a.png";